import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';

import { ShouldRender } from '../../components/shared/basic/ShouldRender';
import { notify } from '../../components/shared/notify';

const SchoolsDashBoard = dynamic(
  () => import('../../components/ResourcesPage/SchoolsPage'),
);
const HeroSection = dynamic(
  () => import('../../components/V2/HomePage/HeroSection'),
);

export interface metaTagProps {
  metaData: {
    title: string;
    meta_description: string;
    author: string;
    keywords: string;
    name: string;
    description: string;
    canonical?: string;
    meta_title?: string;
    documents: {
      id: number;
      parent_id: number;
      type: string;
      sub_type: null;
      file_path: string;
      created_at: string | null;
      updated_at: string | null;
      deleted_at: string | null;
      name: string;
    };
  } | null;

  canonicalUrlPageUrl?: string;
}

const Schools: React.FC<metaTagProps> = ({ metaData }) => {
  

  const router = useRouter();

  

  

  return (
    <>
      <Head>
        <title>
          Finance School | Dive into Comprehensive Finance Education
        </title>

        <title>{metaData?.title || ''}</title>
        <meta
          name='description'
          content={metaData?.meta_description || ''}
          key='description'
        />
        <meta name='author' content={metaData?.author || ''} />
        <meta name='keywords' content={metaData?.keywords || ''} />

        <meta property='og:title' content={metaData?.name || ''} />
        <meta
          property='og:description'
          content={metaData?.meta_description || ''}
        />
      </Head>
      <div className='flex flex-col gap-y-2'>
        <ShouldRender check={router.isReady}>
          <HeroSection isSchool={true} />
        </ShouldRender>

        <div className='flex pb-10 '>
          <SchoolsDashBoard />
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async () => {
  try {
    const metaData = {
      title: 'Finance School | Dive into Comprehensive Finance Education',
      meta_description:
        'Dive into comprehensive finance education with ZebraLearn, your premier Finance School. Explore financial management articles, finance courses, and learn about insurance.',
      author: 'Zebralearn',
      keywords: [''],
      name: 'School',
    };

    return {
      props: {
        metaData: metaData,
      },
      revalidate: 60 * 60,
    };
  } catch (error) {
    notify('Error fetching metaData:', 'error');
    return {
      props: {
        metaData: null,
      },
      revalidate: 60 * 5,
    };
  }
};

export default Schools;
